import React from "react";

export function ScoreRing({
  score,
  scoreLabel,
  pages,
  pagesLabel,
  summary,
}: {
  score: number | null;
  scoreLabel: string;
  pages: number | null;
  pagesLabel: string;
  summary: string;
}) {
  const size = 104;
  const stroke = 8;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const fraction = score == null ? 0 : Math.max(0, Math.min(100, score)) / 100;
  const dash = circumference * (1 - fraction);
  const pagesLine =
    pages == null ? "Pages crawled were not stored." : `${pagesLabel} pages crawled.`;

  return (
    <div className="flex items-center gap-4">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="img"
        aria-label={summary}
        className="shrink-0"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
          className="stroke-border"
        />
        {score != null ? (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            strokeWidth={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={dash}
            strokeLinecap="round"
            className="stroke-primary"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        ) : null}
        <text
          x="50%"
          y="54%"
          textAnchor="middle"
          className="fill-foreground font-mono text-[22px] font-semibold"
        >
          {score == null ? "—" : scoreLabel}
        </text>
      </svg>
      <div>
        <p className="text-sm font-medium">{score == null ? "No on-page score" : "On-page score"}</p>
        {score != null ? <p className="text-sm text-foreground/75">of 100</p> : null}
        <p className="mt-1 text-sm text-foreground/75">{pagesLine}</p>
        <p className="sr-only">{summary}</p>
      </div>
    </div>
  );
}
